export interface StoredProcReport {
  storedProc: string;
  schema: string;
  query?: never;
}

export interface ParameterizedQueryReport {
  query: string;
  storedProc?: never;
  schema?: never;
}

export interface BaseReport {
  reportName: string;
  description: string;
  parameters: ReportParameter[];
  hosts: { hostname: string; database: string; targetDB?: string }[];
}

export type Report = BaseReport & (StoredProcReport | ParameterizedQueryReport);

export enum ReportParameterTypes {
  STRING = "string",
  NUMBER = "number",
  STRING_LIST = "string-list",
  OPTIONS = "options",
  DATE = "date",
}

export interface ReportParameterOption {
  name: string;
  value: string | number;
}

export enum ReportValidationType {
  MIN_LENGTH = "minLength",
  MAX_LENGTH = "maxLength",
  EMAIL = "email",
  REGEXP = "regExp",
}

export interface ReportParameterValidations {
  validationType: ReportValidationType;
  value: string | number;
}

export interface ReportParameter {
  name: string;
  type: ReportParameterTypes;
  example: string;
  required: boolean;
  validators?: ReportParameterValidations[];
  options?: ReportParameterOption[];
  displayName?: string;
}

export interface ReportRequestBody {
  reportName: string;
  hostName: string;
  category: string;
  inputs: { [key: string]: string };
}

export interface ReportResponseBody {
  recordset: { [key: string]: any }[];
  rowsAffected: number[];
  output: { [key: string]: any };
}
